export default __webpack_public_path__ + "static/media/thumb1.a8b534c2.png";